import gql from 'graphql-tag';
import { FrameWeatherFragment } from './group/fragments';

const GroupFragment = gql`
  fragment GroupFragment on Group {
    id
    name
    description
    parentGroup {
      id
      name
    }
    users {
      user {
        id
        firstName
        lastName
        profilePicture {
          url
        }
      }
      roles {
        id
        category
      }
      permissions {
        edit
        remove
      }
    }
    frames {
      frame {
        id
        serialNumber
        name
        weather {
          ...FrameWeatherFragment
        }
      }
      permissions {
        remove
      }
    }
  }
  ${FrameWeatherFragment}
`;

export default GroupFragment;
